module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/photographer_sns-7582b1132d20ac725ca6be17b66e3401.jpg";